import { API_HOST_NAME, URL_CLIENT_SERVICES } from '../../env.js';
import {
  GET_REQUEST,
  POST_FORM_DATA_REQUEST,
  POST_REQUEST,
} from '@helpers/request.js';
import { getCookie } from '@helpers/cookie.js';
import { TOKEN } from '@helpers/constants/index.js';
import axios from 'axios';

const CLIENT_ROOT = API_HOST_NAME + URL_CLIENT_SERVICES;
const structurePaths = {
  clientsList: CLIENT_ROOT + '/clients',
  saveNote: CLIENT_ROOT + '/client/saveNote',
  clientDetail: CLIENT_ROOT + '/client-detail',
  clientDetailPaginator: CLIENT_ROOT + '/client-policies/client',
  assaLovs: API_HOST_NAME + '/assa/lovs',
  clientCareHistory: API_HOST_NAME + '/assa/activities',
  clientCareGetDocument: API_HOST_NAME + '/assa/document',
  saveClientCare: API_HOST_NAME + '/assa/activities',
  clientCareActivities: API_HOST_NAME + '/assa/clients',
  clientCareActivitiesBulk: API_HOST_NAME + '/assa/activities/bulk',
};
export const getClientListService = ({ data }) => {
  return POST_FORM_DATA_REQUEST(structurePaths.clientsList, data);
};
export const updateNoteService = ({ data }) => {
  return POST_FORM_DATA_REQUEST(structurePaths.saveNote, data);
};

export const getClientDetailsService = ({ data }) => {
  return POST_FORM_DATA_REQUEST(structurePaths.clientDetail, data);
};
export const getPolicyListForClientService = ({ data }) => {
  return POST_FORM_DATA_REQUEST(structurePaths.clientDetailPaginator, data);
};

export const getAssaLovsService = () => {
  return GET_REQUEST(structurePaths.assaLovs);
};

export const getClientCareHistoryService = ({ clientId, page, size, sort }) => {
  const params = {
    clientId: clientId,
    page: page,
    size: size,
    sort: sort,
  };

  return GET_REQUEST(structurePaths.clientCareHistory, params);
};

export const getClientCareDocument = (documentId) => {
  const SPAccessToken = getCookie(TOKEN.SP_ACCESS_TOKEN);
  return axios.get(
    `${structurePaths.clientCareGetDocument}?documentId=${documentId}`,
    {
      responseType: 'blob', // this is important!
      headers: {
        Authorization: `Bearer ${SPAccessToken}`,
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
      },
    },
  );
};

export const saveClientCareService = ({ activity, document }) => {
  var payload = {
    activity: activity,
  };

  if (document) payload.document = document;

  return POST_FORM_DATA_REQUEST(structurePaths.saveClientCare, payload);
};

export const getClientCareActivitiesService = ({
  policy,
  name,
  phone,
  month,
  level,
  sort,
  page,
  size,
}) => {
  const params = {
    policy: policy,
    name: name,
    phone: phone,
    month: month,
    level: level,
    sort: sort,
    page: page,
    size: size,
  };

  return GET_REQUEST(structurePaths.clientCareActivities, params);
};

export const saveClientCareListService = (body) => {
  return POST_REQUEST(structurePaths.clientCareActivitiesBulk, body);
};
